var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Ad } from './ad';
import { Store } from './store';
import { Data } from './data';
var Brand = /** @class */ (function (_super) {
    __extends(Brand, _super);
    function Brand() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.class = "Brand";
        _this.features = [];
        _this.themes = {};
        _this.extra = {};
        _this.payments = [];
        return _this;
    }
    Brand.prototype.toProperty = function (name, value) {
        if (name == "stores") {
            return Data.toDataArray(Store, value);
        }
        else if (name == "ads") {
            return Data.toDataArray(Ad, value);
        }
        return value;
    };
    Brand.prototype.hasFeature = function (feature) {
        if (this.features) {
            return this.features.indexOf(feature) >= 0;
        }
        return false;
    };
    return Brand;
}(Data));
export { Brand };
//# sourceMappingURL=brand.js.map